// extracted by mini-css-extract-plugin
export default {"section2":"Section2_section2__P9Pjc"};